import { Options, Vue } from 'vue-class-component';
import HeaderStepper from '../header-stepper/index.vue';
import EoiWording from '../../assets/config/eoi-wording.json';
import { NavStep, NavStepStatusID, Section, Step } from '../header-stepper/nav-step';
import { Inject, Watch } from 'vue-property-decorator';
import { RouteN } from '@/constants/route-name';
import LoadingSpinner from '../loading-spinner/index.vue';
import DetailsPage from '../details/index.vue';
import Membership from '../membership/index.vue';
import Application from '../application/index.vue';
import Preferences from '../preferences/index.vue';
import Review from '../review/index.vue';
import Confirmation from '../confirmation/index.vue';
import store from '@/store';
import { EventEmitter } from 'events';
import { EoiFormView } from '@/modules/typescript-cmpApi-client/models';
import { CMPApi } from '@/modules/cmp-api';
import { AppInsights } from '@/appInsights';
import moment from 'moment';
import _ from 'lodash';


@Options({
  props: {
    // msg: String
  },
  components: {
    LoadingSpinner,
    HeaderStepper,
    DetailsPage,
    Membership,
    Application,
    Preferences,
    Review,
    Confirmation
  }
})
export default class EoiApply extends Vue {
  // msg!: string
  navSteps: NavStep[] = [];

  private isLoadingData = false;
  private backButtonVisible = true;
  private backButtonText = 'Back';
  private nextButtonText: string | undefined;
  private canSubmit = false;

  @Inject({ from: 'apiService', default: new CMPApi() })
  private apiService!: CMPApi;

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  private ai = new AppInsights;

  private eoiForm: EoiFormView = {};
  private eoiEndDate = '';
  private committeeYear = '';

  @Watch('$route')
  public OnRouteChange(val: any, oldVal: any): void {
    window.scrollTo(0, 0);
    // console.log('route changed: ', val, oldVal);
    if (oldVal.fullPath.indexOf('confirmation') > -1) {
      this.$router.push({ name: RouteN.CMP.Dashboard.n });
    }
    this.setCurrentStep();
  }

  // @Watch('eoiForm')
  // public onEoiFormChange(newVal: any, oldVal: any): void {
  //   console.log('EOI value changed: ' , this.eoiForm);
  // }

  created() {
    const section: string = this.$route.query.sec as string;
    // console.log('page section: ', section);
    if (section == 'confirmation') {
      this.$router.push('/dashboard');
    }
    if (section == 'overview') {
      window.sessionStorage.setItem('eoiPageSection', '0');
    }
    this.populateNavSteps();
    this.nextButtonText = 'I agree';

    this.eventCtrl.on('canSubmit', (val) => {
      if (val) {
        this.canSubmit = true;
      } else {
        this.canSubmit = false;
      }
    });
  }

  mounted() {
    window.scrollTo(0, 0);
    // check if eoi from is in progress
    const eoiString = window.sessionStorage.getItem('eoiForm');

    this.eoiForm = eoiString == null ? null : JSON.parse(eoiString);
    if (this.eoiForm == null) {
      this.$router.push({name: RouteN.CMP.Dashboard.n});
    } else {
      this.committeeYear = this.eoiForm.year.committeeYear;
      this.eoiEndDate = this.eoiForm.year.eoiPeriodEnd;
    }
    this.eventCtrl.on('isLoadingData', this.showLoading);
  }

  unmounted() {
    this.eventCtrl.removeListener('isLoadingData', this.showLoading);
  }

  private showLoading(isLoading: boolean) {
    this.isLoadingData = isLoading;
  }

  get pageTitle(): string {
    return "Expression of Interest - Membership of Law Society Committees for"
  }
  get pageHeader(): string {
    return EoiWording[0].overview['pageHeader']
  }

  get pageBody(): string {
    let htmlText = EoiWording[0].overview['pageBody'].replace('-{{YYYY}}-', this.committeeYear);
    htmlText = htmlText.replace('-{{DD Month YYYY}}-', moment(this.eoiEndDate).format('DD MMM YYYY').toUpperCase());
    return htmlText;
  }

  private setCurrentStep(): string {
    const section: string = this.$route.query.sec as string;
    this.backButtonText = 'Back';
    switch (section) {
      case Section.overview:
        this.setSteps(0);
        this.backButtonVisible = true;
        if (this.eoiForm.id > 0) {
          this.backButtonText = 'Back to dashboard';
        } else {
          this.backButtonText = 'Cancel Application';
        }
        this.nextButtonText = 'I agree';
        this.eventCtrl.emit('canSubmit', true);
        break;
      case Section.details:
        this.setSteps(1);
        this.backButtonVisible = true;
        this.nextButtonText = 'Next';
        break;
      case Section.membership:
        this.setSteps(2);
        this.backButtonVisible = true;
        this.nextButtonText = 'Next';
        break;
      case Section.application:
        this.setSteps(3);
        this.backButtonVisible = true;
        this.nextButtonText = 'Next';
        break;
      case Section.preferences:
        this.setSteps(4);
        this.backButtonVisible = true;
        this.nextButtonText = 'Next';
        break;
      case Section.review:
        this.setSteps(5);
        this.backButtonVisible = true;
        this.nextButtonText = 'Submit Application';
        break;
      case Section.confirmation:
        this.setSteps(6);
        this.backButtonVisible = false;
        this.nextButtonText = 'Close';
        break;
      default:
      //
    }
    return section;
  }

  private setSteps(n: number) {
    for (let i = 0; i < this.navSteps.length; i++) {
      this.navSteps[i].status = NavStepStatusID.NotDone
    }
    for (let i = 0; i < n; i++) {
      this.navSteps[i].status = NavStepStatusID.Done
    }
    this.navSteps[n].status = NavStepStatusID.Current
    // the confirmation page
    if (n === 6) {
      for (let i = 0; i < 6; i++) {
        this.navSteps[i].status = NavStepStatusID.Unknown
      }
    } else {
      // save the current step
      window.sessionStorage.setItem('eoiPageSection', n.toString());
    }
  }

  private populateNavSteps(): void {
    this.navSteps = [
      new NavStep(Step.overview, Section.overview, true, NavStepStatusID.Current),
      new NavStep(Step.details, Section.details),
      new NavStep(Step.membership, Section.membership),
      new NavStep(Step.application, Section.application),
      new NavStep(Step.preferences, Section.preferences),
      new NavStep(Step.review, Section.review),
      new NavStep(Step.confirmation, Section.confirmation)
    ];
  }

  private navigate(s: NavStep): void {
    const temp: string = JSON.stringify(this.$route.query);
    const tempJSON = JSON.parse(temp);
    tempJSON.sec = s.routeSecName;
    this.$router.push({ query: tempJSON });
  }

  private backButton(): void {
    const section: string = this.$route.query.sec as string;
    switch (section) {
      case Section.overview:
        this.$router.push({ name: RouteN.CMP.Dashboard.n });
        break;
      case Section.details:
        this.navigate(this.navSteps[0]);
        this.eventCtrl.emit('canSubmit', true);
        break;
      case Section.membership:
        this.navigate(this.navSteps[1]);
        break;
      case Section.application:
        this.navigate(this.navSteps[2]);
        break;
      case Section.preferences:
        this.navigate(this.navSteps[3]);
        break;
      case Section.review:
        this.navigate(this.navSteps[4]);
        break;
      case Section.confirmation:
        this.$router.push({ name: RouteN.CMP.Dashboard.n });
        break;
      default:
        break;
    }
    
    this.saveTempEoiForm();
  }

  private forwardButton(): void {
    const section = this.$route.query.sec as string;
    switch (section) {
      case Section.overview:
        this.eoiForm.acceptOverview = true;
        this.navigate(this.navSteps[1]);
        break;
      case Section.details:
        this.navigate(this.navSteps[2]);
        break;
      case Section.membership:
        this.navigate(this.navSteps[3]);
        break;
      case Section.application:
        this.navigate(this.navSteps[4]);
        break;
      case Section.preferences:
        this.navigate(this.navSteps[5]);
        break;
      case Section.review:
        this.eoiFormSubmit();
        break;
      case Section.confirmation:
        this.$router.push({ name: RouteN.CMP.Dashboard.n });
        break;
      default:
        break;
    }
    
    this.saveTempEoiForm();
  }

  private saveTempEoiForm() {
    if (this.eoiForm !== {}) {
      // clean up data, remove duplicated just incase 
      const tempList = this.eoiForm.committeeMembers.filter((committee: any) => committee.id !== undefined);
      this.eoiForm.committeeMembers = _.uniqBy(tempList, 'committeeId');

      store.dispatch('setEoiForm', this.eoiForm);
    } else {
      store.dispatch('setEoiForm', null);
      window.sessionStorage.removeItem('eoiForm');
    }
  }

  private eoiFormSubmit() {
    this.eventCtrl.emit('isLoadingData', true);
    this.apiService.memberApi?.apiV1MemberSaveMyEoiFormPost(this.eoiForm as any)
      .then((res: any) => {
        // console.log('eoiFormSubmit responses', res);
        this.eventCtrl.emit('show-snackbar', 'success', 'Application submitted.');
        this.navigate(this.navSteps[6]);
        store.dispatch('setEoiForm', null);
        this.eventCtrl.emit('isLoadingData', false);
      })
      .catch((err: any) => {
        console.log(err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Error submitting EOI form: ' + err);
        this.ai.trackException('Error getting details info: ' + err);
        this.eventCtrl.emit('isLoadingData', false);
      })
  }

}
